import Header from './components/Header';
import Hero from './components/Hero';
import UpdatesSection from './components/UpdatesSection';
import TopicsSection from './components/TopicsSection';
import CarouselSection from './components/CarouselSection';
import ContactSection from './components/ContactSection';
import AboutSection from './components/AboutSection';
import FeaturesSection from './components/FeaturesSection';
import IndexSection from './components/IndexSection';
import CommentsSection from './components/CommentsSection';
import MediaSection from './components/MediaSection';
import RankingSection from './components/RankingSection';
import FaqSection from './components/FaqSection';
import CardsSection from './components/CardsSection';
import AppSection from './components/AppSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <UpdatesSection />
        <TopicsSection />
        <CarouselSection />
        <ContactSection />
        <AboutSection />
        <FeaturesSection />
        <IndexSection />
        <CommentsSection />
        <MediaSection />
        <RankingSection />
        <FaqSection />
        <CardsSection />
        <AppSection />
      </main>
      <Footer />
    </>
  );
}